import { render, staticRenderFns } from "./ArticleInfoBreadcrumbs.vue?vue&type=template&id=4d4e3d49"
import script from "./ArticleInfoBreadcrumbs.vue?vue&type=script&lang=ts"
export * from "./ArticleInfoBreadcrumbs.vue?vue&type=script&lang=ts"
import style0 from "./ArticleInfoBreadcrumbs.vue?vue&type=style&index=0&id=4d4e3d49&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports